module.exports = __webpack_public_path__ + "static/media/mathsBoard.c8a495af.png";